import { SeznamAutocomplete } from '../types/external/seznamAutocomplete';

/** Např. "Vinohradská 1409/12, 120 00 Praha 2 - Vinohrady, Česko" */
export const formatSeznamAddress = ({ data }: SeznamAutocomplete) =>
  [data.name, [data.zip, data.location].filter(Boolean).join(' ')].filter(Boolean).join(', ');
